export default __webpack_public_path__ + "static/media/nft-lp-rings.2230b41e.png";